import { createI18n } from 'vue-i18n';

export function loadLocalMessage() {
  const locale = require.context('@/locale', true, /\.json$/);
  const messages = {};

  for (const file of locale.keys()) {
    if (file === './index.js') continue;
    const path = file.replace(/(\.\/|\.json$)/g, '').split('/');

    path.reduce((o, s, i) => {
      if (o[s]) return o[s];
      o[s] = i + 1 === path.length ? locale(file) : {};
      return o[s];
    }, messages);
  }

  return messages;
}

const options = {
  legacy: false,
  locale: 'ko',
  globalInjection: true,
  fallbackLocale: 'en',
  messages: loadLocalMessage(),
  silentTranslationWarn: true,
  warnHtmlMessage: false // [intlify] Detected 에러 안뜨게 함
};

export default createI18n(options);
